export default __webpack_public_path__ + "static/shutterstock_8-df0e53b1e31e6be0f81a5e5b926a3664.jpg";